var map = {
	"./cockfight-sv388.webp": [
		1552,
		1552
	],
	"./gogoli-casino.webp": [
		4744,
		4744
	],
	"./marble-marblex.webp": [
		5544,
		5544
	],
	"./racing-rcb988.webp": [
		1966,
		1966
	],
	"./sport-maxbet.webp": [
		9855,
		9855
	],
	"assets/images/sports/cockfight-sv388.webp": [
		1552,
		1552
	],
	"assets/images/sports/gogoli-casino.webp": [
		4744,
		4744
	],
	"assets/images/sports/marble-marblex.webp": [
		5544,
		5544
	],
	"assets/images/sports/racing-rcb988.webp": [
		1966,
		1966
	],
	"assets/images/sports/sport-maxbet.webp": [
		9855,
		9855
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5287;
module.exports = webpackAsyncContext;